import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../../redux/slices/loadingSlice";
import store from "../../redux/store";
import { showToast } from "../../redux/slices/toastSlice";
import { removeToken } from "../../redux/slices/loginSlice";
import { toastIgnore } from "./toastIgnore";

const BASE_URL = "https://api.7-trade.ir/api";
const TIMEOUT = 600000;

axios.defaults.baseURL = BASE_URL;
axios.defaults.timeout = TIMEOUT;

// let expiration = moment(JSON.parse(localStorage.getItem("sayahUser"))?.expiration);
// let current = moment();

// if (expiration <= current) {
//   await store.dispatch(setLogoutAction());
// }

axios.defaults.headers.common["Authorization"] = `Bearer ${
  localStorage.getItem("token") || null
}`;


const requestOnFullFilled = (config) => {
  if (config.method && config.method.toLowerCase() === "get") {
    store.dispatch(showLoading());
  }
  return config;
};

const requestOnRejected = (error) => {
  if (
    error.config &&
    error.config.method &&
    error.config.method.toLowerCase() === "get"
  ) {
    store.dispatch(hideLoading());
  }
  return Promise.reject(error);
};

const responseOnRejected = async (error) => {
  store.dispatch(hideLoading());
  console.error("API Error:", error);
  if (!error.response) {
    if (
      error.code === "NETWORK_ERR" ||
      error.message.includes("Network Error")
    ) {
      store.dispatch(
        showToast({
          message: "لطفا اتصال اینترنت خود را بررسی کنید",
          type: "error",
        })
      );
    } else if (
      error.code === "ECONNABORTED" ||
      error.message.includes("timeout")
    ) {
      store.dispatch(
        showToast({
          message: "مهلت زمانی درخواست تمام شد، دوباره تلاش کنید",
          type: "error",
        })
      );
    } else {
      store.dispatch(
        showToast({
          message: "خطا در برقراری ارتباط با سرور",
          type: "error",
        })
      );
    }
    throw error;
  }

  const { status, data } = error.response;

  switch (status) {
    case 400:
      store.dispatch(
        showToast({
          message: data?.message || "درخواست نامعتبر است",
          type: "error",
        })
      );
      break;

    case 401:
      console.warn("🔐 Unauthorized - Logging out...");
      store.dispatch(removeToken());
      console.log("User token removed from store.");
      store.dispatch(
        showToast({
          message: "نشست شما منقضی شده، مجدداً وارد شوید",
          type: "error",
        })
      );
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      break;

    case 403:
      console.warn("🔒 Forbidden - Access denied");
      store.dispatch(
        showToast({
          message: "شما اجازه دسترسی به این بخش را ندارید",
          type: "error",
        })
      );
      break;

    case 404:
      store.dispatch(
        showToast({
          message: "صفحه یا اطلاعات درخواستی یافت نشد",
          type: "error",
        })
      );
      break;

    case 422:
      store.dispatch(
        showToast({
          message: data?.message || "اطلاعات ارسالی نامعتبر است",
          type: "error",
        })
      );
      break;

    case 429:
      store.dispatch(
        showToast({
          message: "تعداد درخواست‌ها زیاد است، کمی صبر کنید",
          type: "error",
        })
      );
      break;

    case 500:
      store.dispatch(
        showToast({
          message: "خطای داخلی سرور، لطفا بعدا تلاش کنید",
          type: "error",
        })
      );
      break;

    case 502:
    case 503:
      store.dispatch(
        showToast({
          message: "سرور در حال حاضر در دسترس نیست",
          type: "error",
        })
      );
      break;

    case 504:
      store.dispatch(
        showToast({
          message: "سرور پاسخ نداد، دوباره تلاش کنید",
          type: "error",
        })
      );
      break;

    default:
      store.dispatch(
        showToast({
          message: data?.message || `خطای غیرمنتظره (کد: ${status})`,
          type: "error",
        })
      );
  }

  throw error;
};

axios.interceptors.request.use(requestOnFullFilled, requestOnRejected);

axios.interceptors.response.use(undefined, responseOnRejected);

const isMutatingMethod = (method) => {
  if (!method) return false;
  const m = String(method).toLowerCase();
  return m === "post" || m === "put" || m === "delete" || m == "patch";
};

const extractMessage = (obj) => {
  return (
    obj?.response?.data?.data?.en_message ||
    obj?.data?.data?.en_message ||
    obj?.en_message ||
    obj?.data?.en_message ||
    obj?.response?.data?.en_message ||
    obj?.response?.en_message ||
    obj?.data?.en_message ||
    "خطایی رخ داده است!"
  );
};

const responseBody = (response) => {
  try {
    const method = response?.config?.method;
    if (toastIgnore.includes(response?.config?.url)) {
      return response;
    }
    if (isMutatingMethod(method)) {
      const message = extractMessage(response) || "عملیات با موفقیت انجام شد";
      store.dispatch(showToast({ type: "success", message }));
    }
  } catch (e) {
    console.error("toast responseBody error:", e);
  } finally {
    store.dispatch(hideLoading());
  }

  return response;
};

const errorBody = (error) => {
  try {
    const method =
      error?.config?.method ||
      error?.response?.config?.method ||
      error?.request?.method;
    
    // بررسی آدرس برای ignore کردن نوتیفیکیشن
    const shouldIgnore =
      toastIgnore.includes(error?.config?.url) ||
      toastIgnore.includes(error?.response?.config?.url);
    
    if (shouldIgnore) {
      console.log("⚠️ Error caught but notification ignored (toastIgnore)");
      return Promise.reject(error);
    }
    
    if (isMutatingMethod(method)) {
      const message = extractMessage(error) || "مشکلی در انجام عملیات رخ داد";
      store.dispatch(showToast({ type: "error", message }));
    }
  } catch (e) {
    console.error("❌ Exception in errorBody:", e);
  } finally {
    store.dispatch(hideLoading());
  }
  
  throw error?.response || error;
};

const requests = {
  get: (url) => axios.get(url).then(responseBody).catch(errorBody),
  getByParams: (url, params) =>
    axios.get(url, { params }).then(responseBody).catch(errorBody),
  post: (url, body) =>
    axios.post(url, body).then(responseBody).catch(errorBody),
  put: (url, body) => axios.put(url, body).then(responseBody).catch(errorBody),
  patch: (url, body) =>
    axios.patch(url, body).then(responseBody).catch(errorBody),
  delete: (url) => axios.delete(url).then(responseBody),
  postFormData: (url, formData) => {
    return axios
      .post(url, formData, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody);
  },
  putMedia: (url, body) => {
    return axios
      .put(url, body, {
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
      })
      .then(responseBody)
      .catch(errorBody);
  },
};

export default requests;
